import React from "react";
import { PHILOSOPHY } from "@/lib/content";

const InvestmentPhilosophy = () => {
  return (
    <section
      id="filosofia"
      data-testid="philosophy-section"
      className="relative bg-[#0B0410] text-[#F9F6F0] py-24 lg:py-32 border-t border-white/5 overflow-hidden"
    >
      {/* Decorative vertical "PHILOSOPHY" word watermark */}
      <div
        className="absolute inset-y-0 right-0 hidden xl:flex items-center pointer-events-none opacity-[0.045] select-none"
        aria-hidden="true"
      >
        <span
          className="font-display text-[18rem] leading-none text-[#E6D5B8] tracking-tighter"
          style={{ writingMode: "vertical-rl", transform: "rotate(180deg)" }}
        >
          Philosophia
        </span>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-end mb-20">
          <div className="lg:col-span-8">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-[#E6D5B8]" />
              <span
                className="text-[11px] tracking-luxury uppercase text-[#E6D5B8] font-medium"
                data-testid="philosophy-eyebrow"
              >
                Filosofía de inversión
              </span>
            </div>
            <h2
              className="font-display text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.08]"
              data-testid="philosophy-headline"
            >
              Cuatro principios{" "}
              <span className="italic text-[#E6D5B8]">no negociables</span>{" "}
              detrás de cada plan EMB.
            </h2>
          </div>
          <div className="lg:col-span-4">
            <p className="text-base lg:text-lg text-[#F9F6F0]/65 font-light">
              No son frases promocionales. Son reglas que aplicamos en cada
              estrategia y que sostienen ante mercados volátiles, modas y
              presión comercial.
            </p>
          </div>
        </div>

        {/* Principles: editorial 2-column with large roman numerals */}
        <div className="grid md:grid-cols-2 gap-x-12 gap-y-14">
          {PHILOSOPHY.map((p, idx) => (
            <article
              key={p.n}
              data-testid={`philosophy-principle-${idx}`}
              className="group relative"
            >
              <div className="flex items-baseline gap-6 mb-4">
                <span className="font-display italic text-5xl lg:text-6xl text-[#E6D5B8]/85 leading-none">
                  {p.n}
                </span>
                <span className="h-px flex-1 bg-gradient-to-r from-[#E6D5B8]/40 to-transparent" />
              </div>
              <h3 className="font-display text-2xl lg:text-3xl font-light leading-tight text-[#F9F6F0] mb-4">
                {p.title}
              </h3>
              <p className="text-base text-[#F9F6F0]/70 font-light leading-relaxed">
                {p.body}
              </p>
            </article>
          ))}
        </div>

        {/* Signature block */}
        <div
          data-testid="philosophy-signature"
          className="mt-20 pt-12 border-t border-white/10 grid md:grid-cols-12 gap-8 items-center"
        >
          <div className="md:col-span-8">
            <p className="font-display italic text-xl lg:text-2xl text-[#F9F6F0]/85 leading-snug font-light">
              "El propósito de un asesor no es predecir el futuro: es preparar
              tu patrimonio para lo que el futuro traiga."
            </p>
            <div className="mt-4 text-[11px] tracking-luxury uppercase text-[#E6D5B8]">
              Marco S. Equis · Fundador EMB Consulting Group
            </div>
          </div>
          <div className="md:col-span-4 md:text-right">
            <button
              data-testid="philosophy-cta"
              onClick={() => {
                const el = document.getElementById("contacto");
                if (el) el.scrollIntoView({ behavior: "smooth" });
              }}
              className="inline-flex items-center gap-2 border border-[#E6D5B8] text-[#E6D5B8] hover:bg-[#E6D5B8] hover:text-[#0B0410] text-sm tracking-wider uppercase px-7 py-3.5 rounded-sm transition-all duration-300"
            >
              Hablemos de tu plan
              <span aria-hidden="true">→</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InvestmentPhilosophy;
